module.exports = require('./helpers/bundle-url').getBundleURL('l9LCA') + "logo.7718c6df.svg";